import SendEmail from "./SendEmail";
import FileField from "./FileField";
import CaseZipDownloadField from "./CaseZipDownloadField";
import HideObjectField from "./HideObjectField";
import RiskMatrixField from "./RiskMatrixField";
import RiskMatrixFieldBusiness from "./RiskMatrixFieldBusiness";
import ComputedField from "./ComputedField";
import LookupFormField from "./LookupFormField";
import ConditionalLookupFormField from "./ConditionalLookupFormField";
import LookupMultiSelectCheckboxesFormField from "./LookupMultiSelectCheckboxesFormField";
import TextInput from "./TextInput";
import PhoneInput from "./PhoneInput";
import MoneyInput from "./MoneyInput";
import CedulaInput from "./CedulaInput";
import FetchClientInfoButton from "./FetchClientInfoButton";
import CallUCSAPIButton from "./CallUCSAPIButton";
import EvaluateCreditCapacityField from "./EvaluateCreditCapacityField";
import RiskMatrixDownload from "./RiskMatrixDownload";
import RiskMatrixDownloadBusiness from "./RiskMatrixDownloadBusiness";


const customFields = {
    SendEmail,
    FileField,
    CaseZipDownloadField,
    FetchClientInfoButton,
    CallUCSAPIButton,
    EvaluateCreditCapacityField,
    RiskMatrixField,
    RiskMatrixFieldBusiness,
    RiskMatrixDownload,
    RiskMatrixDownloadBusiness,
    ComputedField,
    HideObjectField,
    LookupFormField,
    ConditionalLookupFormField,
    LookupMultiSelectCheckboxesFormField,
    TextInput,
    PhoneInput,
    MoneyInput,
    CedulaInput
}


export default customFields;